module.exports = __webpack_public_path__ + "img/interior_decoration.af5b9d54.jpg";